import React from 'react';

const Footer = () => {
    return (
        <footer className="l-footer">
            <div className="l-footer__copy">
                <span>© 2024 Fam Inc. All Rights Reserved.</span>
            </div>
        </footer>
    );
};

export default Footer;
